const MODULE_NAME = 'PATIENT_MEASUREMENTS';
const PATIENT_MEASUREMENT_DIARY_TYPE_CHANGED = MODULE_NAME + 'VALUE_TYPE_CHANGED';
const CREATE_NEW_MEASUREMENT_COMPLETED = MODULE_NAME + 'CREATE_NEW_MEASUREMENT_COMPLETED';
const DELETE_MEASUREMENT_COMPLETED = MODULE_NAME + 'DELETE_MEASUREMENT_COMPLETED';
const EDIT_MEASUREMENT_COMPLETED = MODULE_NAME + 'EDIT_MEASUREMENT_COMPLETED';

export {
  PATIENT_MEASUREMENT_DIARY_TYPE_CHANGED,
  CREATE_NEW_MEASUREMENT_COMPLETED,
  DELETE_MEASUREMENT_COMPLETED,
  EDIT_MEASUREMENT_COMPLETED
};
